import UAuth from "@uauth/js";
import { connect } from "@argent/get-starknet";

const uauth = new UAuth({
  clientID: "a20a69da-1099-421d-a9c5-77ebc0503a6a",
  redirectUri: "https://content.pinkpaper.xyz/",
  scope: "openid wallet email profile:optional social:optional"
});

window.login = async () => {
  try {
    const authorization = await uauth.loginWithPopup();

    console.log(authorization);
  } catch (error) {
    console.error(error);
  }
};

window.logout = async () => {
  await uauth.logout();
  console.log("Logged out with Unstoppable");
};

window.loginWithArgent = async () => {
  try {
    const starknet = await connect();
    if (!starknet) {
      throw Error(
        "User rejected wallet selection or silent connect found nothing"
      );
    } else {
      await starknet.enable();

      if (starknet.isConnected) {
        console.log(starknet.selectedAddress);
        // If the extension was installed and successfully connected, you have access to a starknet.js Signer object to do all kinds of requests through the user's wallet contract.
        // starknet.account.execute({ ... })
      } else {
        // In case the extension wasn't successfully connected you still have access to a starknet.js Provider to read starknet states and sent anonymous transactions
        // starknet.provider.callContract( ... )
      }
    }
  } catch (error) {
    console.error(error);
  }
};
